import { render } from "./TreeNode.vue?vue&type=template&id=3de1d1bc&scoped=true&ts=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"

import "./TreeNode.vue?vue&type=style&index=0&id=3de1d1bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de1d1bc"]])

export default __exports__